var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('screening-upload.rki-status.headline')))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n        "+_vm._s(_vm.$t('screening-upload.rki-status.description'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }